export function getHtmlTitle(prefix?: string) {
  if (prefix) {
    return `${prefix} - POSTCARD [*] BY IYK`
  } else {
    return "POSTCARD [*] BY IYK"
  }
}
